import { css } from '@emotion/react';
import { widgetStyles } from '@sitebuilder/common';

const theme = widgetStyles.variables;
const templateEditorStyles = css`
    width: 100%;
    height: 100vh;
    font-size: 14px;
    transition:
        margin 500ms,
        width 0.5s ease-in-out;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    @font-face {
        font-family: 'OpenSans_Regular';
        font-weight: 400;
        font-style: normal;
        src: url('../../assets/fonts/OpenSans-Regular.ttf') format('truetype');
    }

    .pane-header {
        position: fixed;
        top: 0;
        right: 12px;
        height: 68px;
        z-index: 1000;
        padding: 10px 0 8px 10.5px;
    }

    .toolbar {
        display: flex;
        align-items: center;
        width: 390px;
        border-radius: 24px;
        margin-left: 6px;
        box-shadow: 0 3px 6px 0 #00000029;
        background-color: #fff;
        height: 48px;
    }

    .toolbar-button {
        width: 93px;
        height: 29px;
        margin: 10px 16px 9px 6.7px;
        padding: 6px 20px 6px 21px;
        border-radius: 14.5px !important;
        border: 1px solid #2c2e32 !important;
        background-color: #fff;
        font-family: ${theme['$font-family-regular']} !important;
        font-size: ${theme['$font-size-x-small']} !important;
        font-weight: 600;
        color: #2c2e32;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 16px;
            height: 16px;
            margin: 0 8px 0 0;
            object-fit: contain;
        }
    }

    .preview-icon {
        width: 68px;
        height: 48px;
        margin: 0 8px 0 0;
        object-fit: contain;
        cursor: pointer;
    }

    .preview-pdf-icon,
    .preview-ppt-icon {
        width: 25px;
        height: 25px;
        margin: 0 8px 0 0;
        object-fit: contain;
        cursor: pointer;
    }

    .main {
        flex-grow: 1;
        overflow: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
        height: 100vh;
        margin-left: 40px;
        padding-top: 64px;
        background-color: #f7f7f7;
    }

    .main::-webkit-scrollbar {
        display: none;
    }

    .settings-bar {
        position: absolute;
        transition:
            top 0.05s linear,
            left 0.05s linear;
        z-index: 2;
        display: flex;
    }

    .drag-icon,
    .menu-toggle {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #00a4a6;
    }

    .drag-icon {
        border-right: 1px solid #fff;
        cursor: move;
    }

    .menu-toggle {
        cursor: pointer;
    }

    .drag-icon img {
        width: 14px;
        height: 14px;
    }

    .menu-toggle img {
        width: 10px;
        height: 10px;
    }

    .settings-dropdown {
        background-color: white;
        padding: 0.5em;
        box-shadow: 0 3px 6px 0 #00000029;
        border-radius: 8px;
        position: absolute;
        top: 22px;
        width: 7em;

        .menu-item {
            font-size: ${theme['$font-size-x-small']};
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
        }

        .menu-icon {
            width: 13px;
        }
    }

    .Resizer {
        background: ${theme['$color-grey-light']};
        z-index: 1;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .Resizer:hover {
        -webkit-transition: all 2s ease;
        transition: all 2s ease;
    }

    .Resizer.horizontal {
        height: 3px;
        margin: 0;
        cursor: row-resize;
        width: 100%;
    }

    .Resizer.vertical {
        width: 3px;
        margin: 0;
        cursor: col-resize;
    }

    .Resizer.disabled {
        cursor: not-allowed;
    }

    .toolbar-save-button {
        display: flex;
        margin-left: auto;
    }

    .btn {
        padding: 0.1em 1em;
        border: 1px solid ${theme['$color-grey']};
        border-radius: 3px;
        cursor: pointer;
        font-size: ${theme['$font-size-regular']};

        // Disable link underline when class applied to link
        &:link,
        &:active,
        &:hover {
            text-decoration: none;
        }

        &.btn--link {
            background: none;
            border: none;
            font-size: ${theme['$font-size-regular']};
            padding: 0.25em 0;
            text-decoration: underline;
        }

        &.btn--outline {
            border: 1px solid ${theme['$color-grey']};

            &:hover {
                border: 1px solid ${theme['$color-black']};
            }

            &:disabled {
                color: ${theme['$color-grey']};
                border: 1px solid ${theme['$color-grey']};
                cursor: auto;
            }
        }
    }

    #web-data-provider {
        border: 3px double;
    }

    .placeholder {
        cursor: pointer;
        display: block;
        background-color: white;
        opacity: 1;
        min-height: 10px;
        border: 1px solid transparent;

        &:hover {
            border: 1px solid ${theme['$color-grey']};
        }

        &.selected {
            border: 1px solid #00a4a6;
        }
    }

    .add-widget-container {
        border: 2px solid #89cff0;
        min-width: 5px;
        border-radius: 5px;
        cursor: pointer;

        &:hover {
            border: 1px solid #89cff0;
        }

        .add-widget-icon {
            height: 1em;
            width: 100%;
        }
    }

    .right-sidebar-tool {
        width: auto;
        color: $color-soft-black;
        padding-bottom: 2rem;

        button {
            color: $color-soft-black;
            margin-left: 1rem;
            margin-bottom: 5px;
        }

        fieldset {
            margin-bottom: 10px;
        }

        hr {
            color: #fff;
        }

        .accordion_div {
            background-color: transparent !important;
            color: $color-soft-black !important;
            padding: 10px 0px;

            svg {
                color: $color-soft-black !important;
            }

            button {
                color: $color-soft-black;
                padding: 0px 15px;
                width: 100%;
                text-align: left;
                font-size: 18px;
            }

            button img {
                float: right;
                margin-top: 10px;
                transform: inherit;
            }

            button.collapsed img {
                float: right;
                margin-top: 10px;
                transform: rotate(-90deg);
            }

            hr {
                margin: 0px;
            }

            .collapse {
                display: none;
            }

            .collapse.show {
                display: block;
            }
        }
    }

    .zoom-setting {
        .zoom-dropdown {
            display: flex;
            padding: 0;
            font-size: ${theme['$font-size-x-small']};

            .dropdown-menu {
                display: none;
            }
        }

        .dropdown-menu.show {
            display: flex;
            flex-direction: column;
            position: absolute;
            z-index: 1000;
            width: 60px;
            max-height: 10rem;
            overflow-y: auto;
            margin: 0;
            font-size: ${theme['$font-size-regular']};
            color: $color-primary;
            font-weight: normal;
            text-align: left;
            list-style: none;
            background-color: ${theme['$color-white']};
            background-clip: padding-box;
            border: 1px solid ${theme['$color-grey']};
            border-radius: 0.375rem;

            &::-webkit-scrollbar {
                width: 5px;
                height: 5px;
            }

            &::-webkit-scrollbar-track {
                background: ${theme['$color-white']};
            }

            &::-webkit-scrollbar-thumb {
                background: ${theme['$color-grey']};
                border-radius: 5px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: ${theme['$color-grey']};
            }
        }

        .dropdown-toggle {
            width: 60px;
            display: flex;
            margin-right: 1rem;
            align-items: bottom;
            justify-content: flex-start;
            border: none;
            color: ${theme['$color-black']};
            border-width: 0 0 1px;
            border-bottom: 1px solid ${theme['$color-grey']};
            padding-left: 0;

            input {
                border: none;
                width: 50px;
                padding: 0;
                margin: 0 !important;
                outline: none;
                font-size: ${theme['$font-size-x-small']};
                line-height: 0 !important;
            }

            i {
                padding: 0 !important;
                color: $color-soft-black;
                font-size: ${theme['$font-size-xxx-small']};
                margin-top: 0.1rem;
                color: ${theme['$color-grey']};
            }
        }

        .dropdown-item {
            display: flex;
            justify-content: space-between;
            color: ${theme['$color-black']};
            font-size: ${theme['$font-size-x-small']};
            padding: 0 0.5rem;

            .dropdown-item-label {
                cursor: pointer;
            }

            &:hover {
                background-color: ${theme['$color-black']};
                color: ${theme['$color-white']};
            }
        }
    }

    .widget-gallery {
        padding: 1em;

        .widgets-container {
            height: calc(100vh - 160px);
            overflow: scroll;
            -ms-overflow-style: none;
            scrollbar-width: none;
        }

        .widgets-container::-webkit-scrollbar {
            display: none;
        }

        .widget-button {
            display: block;
            margin-bottom: 0.5em;
        }
    }

    .left-side-bar {
        .Pane1 {
            position: unset !important;
        }
    }

    .sidebar {
        padding: 1em;

        .data-display {
            height: 75vh;
        }
    }

    .sidebar-header {
        font-size: ${theme['$font-size-large']};
        margin-bottom: 1em;
    }

    .template-editor-loading {
        position: fixed;
        top: 50%;
        left: 50%;
    }
`;

export default templateEditorStyles;
